import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import data from "../data/patents.json";
import { PatentContext } from "../context/PatentContextProvider";
import { useLocation } from "react-router-dom";
import ViolationModal from "./Modal/ViolationModal";
import Bot from "./ChattingBot";
import Navbar from "./Navbar";
import PatentDescription from "./PatentDescription";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { typeOfVoices } from "../constants/constants";
export default function Claims() {
  const { selectedPatent, active, setActive } = useContext(PatentContext);

  const location = useLocation();

  const { activePatent } = location.state ? location.state : selectedPatent;

  useEffect(() => {
    setActive(active);
    localStorage.setItem("activePatent", JSON.stringify(active));
  }, []);

  const [claimIndex, setClaimIndex] = useState(0);
  const [voiceType, setVoiceType] = useState("Legal");
  const [patentId, setPatentId] = useState('');
  const [textGenerated, setTextGenerated] = useState("");
  const [enableChat, setEnableChat] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [audioPlaying, setAudioPlaying] = useState(false);

  useEffect(() => {
setPatentId(`${activePatent.patentId}Claim${claimIndex + 1}-${voiceType}voice`)
  }, [claimIndex, voiceType])

  const audioRef = useRef(null);
  useEffect(() => {
    const generateSummary = async () => {
      if (!activePatent?.claims) return;
      try {
        const getResponse = await axios.post(
          `${process.env.REACT_APP_API_PATH}/generateSummary`,
          {
            languageStyle: voiceType,
            activePatent: {
              patentNo: activePatent.patentId,
              abstract: activePatent.abstract,
              fieldOfInvention: activePatent.fieldOfInventor,
              claims: activePatent.claims[claimIndex],
            }

          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const summaryGenerated =
          getResponse.data.response.candidates[0]?.content?.parts[0].text
            .replace(/[^\w\s]/g, "")
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
            .replace(/[^\w\s\']|_/g, "")
            .replace(/\s{2,}/g, "");

        if (summaryGenerated) {
          setTextGenerated(summaryGenerated);
        }
      } catch (error) {
        console.log(error, "err");
      }
    };
    generateSummary(voiceType);
  }, [voiceType, patentId, claimIndex]);

  //functions//

  function handleNext() {
    if (
      (activePatent?.claims && claimIndex < activePatent.claims.length - 1) ||
      (selectedPatent?.claims && claimIndex < selectedPatent?.claims.length - 1)
    ) {
      setClaimIndex((prev) => prev + 1);
    }
  }

  function handlePrevious() {
    if (claimIndex > 0) {
      setClaimIndex((prev) => prev - 1);
    }
  }
  //chatbot
  const openChat = () => {
    setEnableChat(true);
  };
  const closeChat = () => {
    setEnableChat(false);
  };

  async function speakSummary(text) {
    setLoading(true); // Start loading
    // if (textGenerated) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_PATH}/generateSpeech/${patentId}`,
          { text: text },
          {
            headers: { "Content-Type": "application/json" },
            responseType: "arraybuffer",
          },
        );

        const blob = new Blob([response.data], { type: "audio/mpeg" });
        const url = URL.createObjectURL(blob);

        // Stop and reset previous audio if playing
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }

        // Create new audio instance
        const audio = new Audio(url);
        audioRef.current = audio;

        audio.addEventListener("play", () => setAudioPlaying(true));
        audio.addEventListener("ended", () => {
          setAudioPlaying(false);
          URL.revokeObjectURL(url); // Clean up URL object
        });

        await audio.play();
        setLoading(false);
      } catch (error) {
        console.error("Error generating speech:", error);
        setLoading(false);
      }
    // }
  }

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setAudioPlaying(false);
  };
  const previousDisabled = claimIndex === 0;
  const nextDisabled = activePatent
    ? activePatent?.claims && claimIndex === activePatent.claims.length - 1
    : selectedPatent?.claims &&
    claimIndex === selectedPatent?.claims.length - 1;

  return (
    <>
      {
        <ViolationModal
          claim={activePatent?.claims[claimIndex]}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      }
      <Navbar />
      <PatentDescription
        patent={activePatent ? activePatent : selectedPatent}
      />
      <div className="flex flex-col justify-between overflow-y-auto  gap-2  pb-16">
        <div className="bg-white py-5 pb-3  md:py-1 px-5 w-[93%] mx-auto max-w-[1350px] rounded-lg relative">
          {location.state ? (
            <div>
              <div className="flex items-center w-[62%] ">
                <div className="w-full md:w-[60%] lg:w-[67%]">
                  <Link
                    to={
                      activePatent
                        ? `/patent-details/${activePatent.patentId.replace(
                          /[\s,]/g,
                          "",
                        )}`
                        : `/patent-details/${selectedPatent.patentId.replace(
                          /[\s,]/g,
                          "",
                        )}`
                    }
                    className="text-[#00A4E5] hover:text-blue-400 underline font-semibold flex text-sm md:text-2xl mt-[-15px]"
                  >
                    <span>
                      <IoIosArrowBack className=" mt-1.5 -ml-3 md:mt-1.5 " />
                    </span>
                    <span> Back to Patent</span>
                  </Link>
                </div>
                <h3 className=" hidden md:block text-3xl lg:text-4xl xl:text-5xl font-semibold leading-2 text-[#00A4E5] md:pt-5 pb-8 font-openfont  text-start">
                  Claim {claimIndex + 1}
                </h3>
                <div className="relative group">
                  <button className="min-w-[225px] md:min-w-[280px] lg:min-w-[302px] md:px-5 py-2 fixed  md:top-[22.5rem] md:right-10 lg:top-[22.5rem] 2xl:right-[18rem] lg:right-14 right-4 px-2  text-sm  top-[21rem] justify-center items-center  bg-[#00A4E5] hover:bg-blue-400  font-semibold flex text-md lg:text-lg mt-[-15px] text-white">
                    Summary Style ( {voiceType} )
                    <svg
                      class="w-2.5 h-2.5 ms-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                    <ul className="absolute right-0 md:w-[17.5rem] top-8 w-[14.1rem] lg:top-11 hidden lg:w-[19rem] bg-white  group-hover:block  border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {typeOfVoices
                        .filter((item) => item !== voiceType)
                        .map((val) => (
                          <li
                            className="block px-4 py-2 text-sm text-[#5c636e]  font-bold hover:bg-gray-600 hover:text-white"
                            onClick={() => setVoiceType(val)}
                          >
                            {val}
                          </li>
                        ))}
                    </ul>
                  </button>
                </div>
              </div>
              <h3 className="text-[#00A4E5] pb-3 pt-6 block text-lg md:hidden font-semibold  font-openfont  text-center">
                Claim {claimIndex + 1}
              </h3>
              <p className="">
                {activePatent?.claims
                  ? activePatent?.claims[claimIndex]
                  : data.patents[0].claims[claimIndex]}
              </p>
            </div>
          ) : (
            <p>{data.patents[0].claims[claimIndex]}</p>
          )}
          <div className="flex px-[-7px] pt-1 pb-40 md:px-2 justify-between lg:px-5 md:pt-5 md:pb-5 ">
            <button
              className={`${previousDisabled
                ? "bg-gray-400 text-gray-200 cursor-not-allowed "
                : "bg-[#00A4E5] "
                } p-3 text-white rounded-md font-semibold`}
              onClick={handlePrevious}
              disabled={previousDisabled}
            >
              Previous
            </button>
            <button
              className={`${nextDisabled
                ? "bg-gray-400 text-gray-200 cursor-not-allowed "
                : "bg-[#00A4E5] "
                } p-3 text-white rounded-md font-semibold hover:bg-blue-400`}
              onClick={handleNext}
              disabled={nextDisabled}
            >
              Next
            </button>
          </div>
        </div>
        <div className="flex justify-center m-auto w-3/4 max-w-md gap-2">
          <div className="fixed bottom-2 gap-2 flex flex-col lg:gap-5 md:mt-20  md:pt-8  md:w-[96%]  lg:flex  lg:flex-row  items-center lg:w-[92%]  justify-center">
            <button
              className="bg-[#00A4E5] px-24 py-2.5   text-white font-bold rounded-lg min-w-[200px]  hover:bg-blue-400"
              onClick={() => setIsModalOpen(true)}
            >
              Check Violations
            </button>
          </div>
        </div>
        <button className="flex items-center justify-center md:w-16 md:h-16  fixed bottom-[124px] right-4  py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-7 md:bottom-20 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-20 lg:right-4">
          {loading ? (
            <span class=" w-6 h-6 border-2 border-t-transparent border-white rounded-full inline-block animate-spin mr-2"></span>
          ) : audioPlaying ? (
            <svg
              class=" w-5 h-5 md:w-8 md:h-8"
              onClick={stopAudio}
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"></path>
            </svg>
          ) : (
            <svg
              onClick={() => speakSummary(textGenerated)}
              class="w-5 h-5 md:w-8 md:h-8 "
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path>
            </svg>
          )}
        </button>
        {enableChat && <Bot closeChat={closeChat} />}
        <button
          className="md:w-16 md:h-16  fixed bottom-[74px] right-4   py-2 px-2 sm:right-5 sm:py-2 sm-px-2 md:right-7 md:bottom-2 md:px-3 md:py-3 md:text-2xl  text-xl z-10 cursor-pointer hover:bg-[#5f6769] bg-[#393e46] text-white rounded-full lg:bottom-1 lg:right-4"
          onClick={openChat}
        >
          <svg
            class="w-5 h-5 md:w-9 md:h-9 lg:w-10 lg:h-10"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
            <path d="M8 12h.01"></path>
            <path d="M12 12h.01"></path>
            <path d="M16 12h.01"></path>
          </svg>
        </button>
      </div>
    </>
  );
}
